exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1BNMQ{margin:24px 16px 8px;margin:1.5rem 1rem .5rem}._2JpG8{width:100vw;height:59.6vw;display:flex}.jcAnK{margin-right:11.2px;margin-right:.7rem;position:relative;max-height:200px}._3oHWk{width:90vw;max-width:396.1px;height:100%}.plggZ{width:75vw;max-width:335px;overflow:hidden;font-size:14px;height:304px;height:19rem}.plggZ div:first-child{height:70%}.plggZ div:last-child{height:30%}.plggZ>a>div>div:first-child{font-size:14px;padding:5px 5px 0;line-height:16px}.plggZ>a>div>div:last-child{line-height:33px;padding:0 5px}.hgUO-{width:60vw;max-width:285.594px;height:100%}._3lqJZ{margin:16px 8px;margin:1rem .5rem}._2ir3s{display:flex;justify-content:space-between;align-items:center;margin:24px 8px 8px;margin:1.5rem .5rem .5rem}._2ir3s span{font-size:22.4px;font-size:1.4rem}._2ir3s a{font-size:16px;font-size:1rem}._1_R-G{margin:16px;margin:1rem}", ""]);

// exports
exports.locals = {
	"title_articles": "_1BNMQ",
	"slider_container": "_2JpG8",
	"article_banner_container": "jcAnK",
	"article_banner_item": "_3oHWk",
	"article_card_recent": "plggZ",
	"article_card_category": "hgUO-",
	"main_container_margin": "_3lqJZ",
	"header_container": "_2ir3s",
	"content_container": "_1_R-G"
};